
import { Card, CardContent, Typography, CardMedia, CardActions, Button, Box, Grid, Divider, Stack } from "@mui/material/"
import prodOne from "../assets/prodOne.png"
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import CustomAxios from '../utils/CustomAxios';
import { useDispatch, useSelector } from "react-redux";
import { updateAllProduct, updateCart } from "../redux/products";
import { useMediaQuery } from "react-responsive";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { json, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ayurvedic from "../assets/ayurvedic.svg"
import organic from "../assets/organic.svg"
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { updateSnackBarMessage,updateSnackBarSeverity,updateSnackBarOpen } from "../redux/snackbar";
import { CurrencyRupee } from "@mui/icons-material";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { styles } from "./product_list";
import { TranslateText } from "../utils/googletranslator";
import { CalculateProductPrice } from "../utils/price";
export const card_styles = {

    card: {},
    header: { fontSize: "16px", fontWeight: 600, },
    unit: { color: "grey.500", fontSize: "14px", },
    price: { color: "grey.500", fontSize: "14px",textDecoration:"line-through" },
    sellingPrice: { fontSize: "16px", fontWeight: 600 },
    Button: {
        textTransform:"none",
        border: "0.5px solid rgba(105, 189, 255, 1)", borderTopLeftRadius: 20,
        height:"40px",
        borderBottomLeftRadius: 20,
        borderTopRightRadius: 20,
        borderBottomRightRadius: 20, "&:hover": { bgcolor: "rgba(105, 189, 255, 1)", color: "#fff" }, display: "flex", alignItems: "center", gap: "8px", padding: "8px", fontSize: "14px",fontWeight:"600" ,width:"90px"
    }
}



const Cards = (props) => {
    const navigate = useNavigate()
    const cart = useSelector(state => state.product?.cart)
    const bg = useSelector(state => state.product?.bg)
    const id = useSelector(state => state.user.id)
    const authtoken = localStorage.getItem("authtoken")
    const member=useSelector(state=>state.user.member)
    const dispatch = useDispatch()
    useEffect(() => {
        // // console.log(product)
        getProducts()
    }, [])
    // // console.log(params.prod)
    useEffect(() => {


    }, [cart])
    const getProducts = async () => {

        await axios(`${process.env.REACT_APP_BACKEND_BASE_URL}products/`,).then(({ data }) => {
            // console.log(data)
            const mergedArray = data?.map(detail => {
                const backgroundClr = bg.find(item => item.id === detail.id);
                return { ...detail, bgcolor: backgroundClr ? backgroundClr.color : null };
            });
            dispatch(updateAllProduct(mergedArray))
            setProduct(mergedArray)

        })
    }
    const isMobile = useMediaQuery({ maxWidth: 600 });
    const [product, setProduct] = useState()
    // // console.log(product)
    const prod = useSelector(state => state.product.Allproducts)
    useEffect(() => {
        setProduct(prod)
    }, [prod])

    const updateQuantity = async (object, condition, event) => {
        // console.log(cart)
        event.stopPropagation();
        let productUpdate=false
        let products = [...cart]
        let notUpdated=false
        const newCart = products.map(item => {
            // console.log(item)
            if (object.available_quantity<=item.quantity&&item.product?.id == object.id&&condition ){
                // console.log("????????????????????????/not update available",object.available_quantity,item.quantity,item.product?.id , object.id)
                notUpdated=true
            }

            // console.log(!condition , item.product?.id , object.id , item.product.inventry_details?.available_quantity>item.quantity)
            if (condition && item.product?.id == object.id && item.product.inventry_details?.available_quantity>item.quantity&&!notUpdated ) {
                let updated = { ...item }
                productUpdate=true
                updated.quantity += 1
                // // console.log("if condition")
                if (item.id) {
                    CustomAxios.patch(`cart/${item.id}/`, {
                        quantity: updated.quantity,
                        totalprice: updated.quantity * (parseFloat(updated.price) + Math.round(updated?.price * (updated.product?.tax / 100)))
                    })
                    return updated
                }
                else {

                    return updated

                }

            }
            else if (!condition && item.product?.id == object.id) {
                productUpdate=true
                let updated = { ...item }
                updated.quantity -= 1

                if (item.id && updated.quantity >= 1) {
                    CustomAxios.patch(`${process.env.REACT_APP_BACKEND_BASE_URL}cart/${item.id}/`, {
                        quantity: updated.quantity,
                        totalprice: updated.quantity * (parseFloat(updated.price) + Math.round(updated?.price * (updated.product?.tax / 100)))
                    })
                    return updated
                }
                else if (item.id && updated.quantity < 1) {
                    CustomAxios.delete(`${process.env.REACT_APP_BACKEND_BASE_URL}cart/${item.id}/`)
                    return updated
                }
                else {

                    return updated

                }


            }
            else if (item.product?.id == object.id){
                // console.log( item.product.inventry_details?.available_quantity, item.quantity)
                if(condition && item.product.inventry_details?.available_quantity<item.quantity) {
                    productUpdate=false
                } 
                else{
                    productUpdate=true
                }
                return item
               

            }
            else{
                return item
            }

        })
        if (productUpdate &&!notUpdated){
            dispatch(updateCart(newCart.filter((item) => !item?.quantity < 1)))
            localStorage.setItem("cart", JSON.stringify(newCart.filter((item) => !item?.quantity < 1)))
            // console.log("clipboard open")
            dispatch(updateSnackBarMessage("Successfully Updated the Cart!"))
            dispatch(updateSnackBarSeverity("success"))
    
            dispatch(updateSnackBarOpen(true))
        }
        else{
            dispatch(updateCart(newCart.filter((item) => !item?.quantity < 1)))
            localStorage.setItem("cart", JSON.stringify(newCart.filter((item) => !item?.quantity < 1)))
            // console.log("clipboard open")
            if (!notUpdated){
                dispatch(updateSnackBarMessage(`You are exceeding the available stock!. You can add only ${object.inventry_details?.available_quantity} quantity to your cart.`))
            }
            else{
                dispatch(updateSnackBarMessage(`We are Restocking.You can purchase only ${object.available_quantity}`))

            }
            
            dispatch(updateSnackBarSeverity("error"))
    
            dispatch(updateSnackBarOpen(true))
        }
        // console.log(newCart)
        // setProduct(products)
        

    }
    const addCart = (item, quantity,e) => {
        e.stopPropagation();
        e.preventDefault()
        const addCart = { product: item, quantity: quantity }
        dispatch(updateCart([...cart, addCart]))
        localStorage.setItem("cart", JSON.stringify([...cart, addCart]))
        if (authtoken) {
            handleCart(item, quantity).then(() => {
                // console.log("clipboard open")
                dispatch(updateSnackBarMessage("Successfully Added to Cart!"))
                dispatch(updateSnackBarSeverity("success"))
              })
              .catch((error) => {
                dispatch(updateSnackBarMessage("You are exceeding the available stock!. You can add only 11 quantity to your cart."))
                dispatch(updateSnackBarSeverity("error"))
              });
              dispatch(updateSnackBarOpen(true))
        }
        
    }
    const handleCart = async (item, quantity) => {
        // console.log(item, quantity, id)

        await CustomAxios.post(`cart/`, {
            products: item.id,
            quantity: quantity,
            user: id, created_by: id,
            price: item.selling_price,
            totalprice: quantity * (parseFloat(item.selling_price) + Math.round(item.selling_price * (item.tax / 100))),
            updated_by: id
        })
        const response = await CustomAxios.get(`usercart/${id}`,)
        // console.log(response)
        dispatch(updateCart(response.data))
        localStorage.setItem("cart", JSON.stringify(response.data))


    }
    const cartCheck = (id) => {
        // // console.log(id)
        // // console.log(cart)
        const filt = cart?.filter(item => item.product?.id == id)
        // filt[0].quantity
        if (filt.length > 0) {
            return filt[0].quantity

        }
        else {
            return false
        }

    }
    const addCartAdding = (item) => {
        let addon = [...cart]
        // console.log(addon)

        const filt = addon.map(ct => {

            if (ct.product?.id == item.id) {
                const quantity = { ...ct }
                quantity.quantity += 1
                // // console.log(quantity)
                return quantity
                // ct.quantity+=1
                // return ct
            }
            else {
                return ct
            }
        })
        dispatch(updateCart(filt))
        localStorage.setItem("cart", JSON.stringify(filt))

        // console.log(filt)

    }
    const productDetails = (id) => {
        // console.log("product id list",id)
        navigate(`/product_details/${id}`)
    }
    const handleCopyurl = () => {
        const url = process.env.REACT_APP_URL + `/product_details/37}`
        navigator.clipboard.writeText(url)
       
    }
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 900, 
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    };
    const sliderRef = useRef(null);

    const handlePrev = () => sliderRef.current.slickPrev();
    const handleNext = () => sliderRef.current.slickNext();
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "30px", width: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between",alignItems:"center" }}>
                <TranslateText sx={{ fontSize: {xs:"20px",sm:"20px",md:"28px"}, fontWeight: "600", lineHeight: "24px" }}>Other Products</TranslateText>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: "8px" }}>
                    <Button variant="contained"
                        sx={{ width: '44px', height: '36px', textAlign: 'center', lineHeight: '36px', borderRadius: '12px',padding: "8px 12px", borderRadius: "4px" }}
                        onClick={handlePrev}
                    >
                        <ChevronLeftIcon />
                    </Button>
                    <Button variant="contained"
                       sx={{ width: '44px', height: '36px', textAlign: 'center', lineHeight: '36px', borderRadius: '12px',padding: "8px 12px", borderRadius: "4px" }}
                        onClick={handleNext}
                    >
                        <ChevronRightIcon />
                    </Button>
                </Box>
            </Box>
            <Slider ref={sliderRef} {...settings} >
                {product?.map((product) => (
                             product.status === "publish" && parseInt(product.id) !== parseInt(props.current_product.id)&&parseInt(props.current_product.category)==parseInt(product.category)&& <Box   sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between",  gap: "24px",padding:"0px 10px" }}>
                             <Box sx={{display:"flex",flexDirection:"column",justifyContent:"space-between",height:"100%",cursor:"pointer",gap:"24px" }} onClick={() => productDetails(product.id)}>
                                 <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
                                 <Box sx={{ width: "100%", display: "flex", justifyContent: "center", background: product.bgcolor,cursor:"pointer" }} >
                                     <Box component="img" sx={{ height: { xs: "100%", sm: "100%", md: "auto" }, width: "100%", maxWidth: { xs: "100%", sm: "100%", md: "100%" },maxWidth:"282px" }} src={product.cover_details?.original} />
                                 </Box>
                                 <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                     <TranslateText sx={styles.productHeading}>{product.name}</TranslateText>
                                     <TranslateText sx={styles.productContent}>{product.details}</TranslateText>
                                     <TranslateText sx={styles.productSize}>Size: {product.unit}</TranslateText>
                                 </Box>
                             </Box>
                             <Box sx={{ display: "flex", flexDirection: "column", gap: "24px",position:"relative", alignItems:"center" }}>
                                        <Stack direction={'row'} gap={{xs:"4px",md:"12px"}}>
                                            {Number(product?.price) > 0 && Number(product?.selling_price) < Number(product?.price) && (
                                                <>
                                                <Typography
                                                    sx={{
                                                    color: "#FF5449",
                                                    fontSize: "16px",
                                                    lineHeight: "120%",
                                                    letterSpacing: "-1.4%",
                                                    fontWeight: 400
                                                    }}
                                                >
                                                  - {Math.round(((product.price - product.selling_price) / product.price) * 100)} %
                                                </Typography>
                                            <Divider orientation="vertical" flexItem sx={{height:"auto"}}/>
                                            </>
                                            )}
                                            {/* <Divider orientation="vertical" flexItem sx={{height:"50%"}}/> */}
                                            <Box sx={{ display: "flex", flexDirection:"column", gap: "2px" }}>
                                                {/* <TranslateText sx={{ fontSize: "12px", fontWeight: "400", color: "error.light", textDecoration: "line-through" }}><CurrencyRupee sx={{ fontSize: "12px", fontWeight: "400", color: "error.light", marginTop: "-1px" }} />{(parseFloat(product.price) + Math.round(product?.price * (product?.tax / 100))).toFixed(2)}</TranslateText>
                                                <Divider orientation="vertical" flexItem />
                                                <TranslateText sx={{ fontSize: "18px", fontWeight: "600", lineHeight: "21.6px" }}><CurrencyRupee sx={{ fontSize: "18px", fontWeight: "600", lineHeight: "21.6", marginTop: "-1px" }} />{(parseInt(product.selling_price) + Math.round(parseInt(product.selling_price) * (parseInt(product.tax) / 100))).toFixed(2)}</TranslateText> */}
                                                        {/* {authtoken &&  */}
                                                        {/* } */}
                                                        {/* {authtoken&&member=='member' && ( */}
                                                            <Box sx={{ display: "flex", gap: {md:"12px",xs:'0px'},flexDirection:"row" }}>       
                                                            <Box sx={{ display: "flex",alignItems:"center"}}>
                                                            <CurrencyRupee sx={{ fontSize: "18px", fontWeight: "600", lineHeight: "21.6", marginTop: "-1px" }} />
                                                            <Typography sx={{ fontSize: "18px", fontWeight: "600", lineHeight: "21.6px" }}>{ 
                                                                // (parseFloat(product.selling_price) + Math.round(parseFloat(product.selling_price) * (parseFloat(product.tax)/100))).toFixed(2) 
                                                                CalculateProductPrice({authtoken:authtoken,member:member,item:{product:product},lineStrike:false})
                                                            }</Typography>
                                                            </Box>
                                                            </Box>
                                                        {/* )} */}
                                                        {Number(product?.price) > 0 && Number(product?.selling_price) < Number(product?.price) && (
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                        {/* {authtoken?  */}
                                                        <Typography sx={{ fontSize: "12px", fontWeight: "400", color: "#6F7883",}}>MRP: </Typography>
                                                            <CurrencyRupee sx={{ fontSize: "12px", fontWeight: "400", color: "#6F7883", marginTop: "-1px" }} />
                                                        {/* :
                                                        <CurrencyRupee sx={{ fontSize: "18px", fontWeight: "600", lineHeight: "21.6", marginTop: "-1px" }} />} */}
                                                            {/* {authtoken&&member=='member' ? (
                                                            <> */}
                                                            <Typography sx={{ fontSize: "12px", fontWeight: "400", color: "#6F7883", textDecoration: "line-through" }}>
                                                            {
                                                                // (parseFloat(product.price) + Math.round(product?.price * (product?.tax/100) )).toFixed(2)
                                                                CalculateProductPrice({authtoken:authtoken,member:member,item:{product:product},lineStrike:true})
                                                            }
                                                                </Typography>
                                                            {/* </>
                                                            ) : 
                                                            <>
                                                        <Typography sx={{ fontSize: "18px", fontWeight: "600", lineHeight: "21.6px" }}>  {
                                                                // (parseFloat(product.price) + Math.round(product?.price * (product?.tax/100) )).toFixed(2)
                                                                CalculateProductPrice({authtoken:authtoken,member:member,item:{product:product},lineStrike:false})
                                                            }</Typography>
                                                            </>
                                                            } */}
                                                        </div>
                                                        )}
                                                        </Box>
                                        </Stack>
                                        {cartCheck(product.id) &&product.inventry_details?.available_quantity>0  && product.available_quantity>0?  <Button onClick={(e) => addCart(null, null, e)} variant="contained" sx={{ width: "100%", bgcolor: "black", height: "36px", padding: "8px 12px", textTransform: "none",display:"flex",gap:"20px"}}>
                                                            <Typography  sx={{ fontSize: "14px", fontWeight: "600", cursor: "pointer",padding:"0px 8px" }}>
                                                            <RemoveIcon sx={{fontSize:"15px"}} onClick={(e) => updateQuantity(product, false, e)} />
                                                            </Typography>

                                                            <Typography sx={{ fontSize: "14px", fontWeight: "600" }}>
                                                                {cartCheck(product.id)}
                                                            </Typography>
                                                            <Typography  sx={{ fontSize: "14px", fontWeight: "600", cursor: "pointer",padding:"0px 8px" }}>
                                                                <AddIcon  sx={{fontSize:"15px"}} onClick={(e) => updateQuantity(product, true, e)}/>
                                                            </Typography>

                                                        </Button> :product.inventry_details?.available_quantity>0&& product.available_quantity>0?
                                        <Button variant="contained" sx={{ width: "100%", bgcolor: "black", height: "36px", padding: "8px 12px", textTransform: "none", }} onClick={(e) => addCart(product, 1, e)}><ShoppingCartOutlinedIcon sx={{ marginRight: "10px" }} /><TranslateText sx={{fontSize:"14px"}}> Add to Cart</TranslateText> </Button>:<Box><TranslateText style={{background: "linear-gradient( 45deg, #00E471 10%,#53AEFF 90%)", WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', textFillColor: 'transparent'}} sx={{ fontSize: "16px", fontWeight: "500", lineHeight:"20px"}}> {product.available_quantity>0?"Out Of Stock":"Restocking in progress"}</TranslateText></Box>}
                                    </Box>
                                </Box>
                                
                            </Box>
                ))}
            </Slider>
        </Box>
    )

}
export default Cards
